import React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import Dashboard from './pages/dashboard/dashboard';
import Loading from './pages/loading';
import Login from './pages/login';

export const navigationPath = {
  dashboard: '/dashboard',
  login: '/login',
  logout: '/logout',
};

const App: React.FC = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route index element={<Loading />} />
        <Route path='/' element={<Navigate to='/login' />} />
        <Route path='/login' element={<Login />} />
        <Route path='/dashboard' element={<Dashboard />} />
        <Route path='/logout' element={<Navigate to='/login' />} />
        <Route path='*' element={<Navigate to='/login' />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
